import { ToothSurface } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';
import { TOOTH_SURFACES_TITLE_MAP } from '../surfaces/toothSurfacesTitleMap';

export default function getHistoryValueSurfaces(surfaces: ToothSurface[]) {
	const { t } = useTranslation();

	const surfacesString = surfaces
		.map(surface => t(TOOTH_SURFACES_TITLE_MAP[surface] ?? ''))
		.join(', ');

	if (!surfacesString) {
		return '';
	}

	return `${t(
		'patientTreatment.meddiDENT.history.text.surfacesPrefix',
	)} ${surfacesString}`;
}
